module.exports = __webpack_public_path__ + "img/Inicio1.167cb497.png";